import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Checkbox, makeStyles, MenuItem, Select, TextField } from '@material-ui/core';
import { lightBlue, teal } from '@material-ui/core/colors';
import { Controller, useForm } from "react-hook-form";

import { sendBrunch } from '../../Actions';
import { formatTelNum } from '../../commonModule';
import { CntbkLinksTab } from './CntbkMake';

const useStyles = makeStyles({
  contBkForm: {
    width: '682px',
    margin: '0 auto',
    paddingTop: 120,
    paddingBottom: 32,
    '& .forms': {
      width: 650,
      margin: '16px auto',
    display: 'flex',
    flexDirection: 'column',
    '& .subTitle': {
      fontSize: '1.125em',
      margin: '16px 0 8px 0'
    },
    '& .linkRow': {
      display: 'flex',
      '& .text': {width: 200, },
    },
    '& .checkboxRow': {
      display: 'flex',
      '& .text': {width: 200, },
    },
    '& .inputRow': {
      display: 'inline-block',
      '& label': {
        display: 'inline-flex',
        margin: '8px 0',
      },
      '& .text': {
        width: 200,
      },
      '& .textLabel > .text': {
        marginTop: 8,
      },
      '& .checkBoxLabel': {
        alignItems: 'center',
        margin: '4px 0'
      },
      '& .inputText': {width: 450},
      '& .inputPhone': {width: 114}
    },
  },
    '& .button': {
      width: '650px',
      textAlign: 'end',
      position: 'fixed',
      right: 'auto',
      bottom: 16,
    }
  }
});

const InputText = (props) => {
  const {control, pattern={}, validate={}, label, path, classNameAdd, helpText} = props;
  return(
    <div className='inputRow'>
      <label className='textLabel'>
        <div className='text'>{label}</div>
        <Controller
          name={path}
          control={control}
          rules={{validate, pattern}}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              type="text"
              className={classNameAdd}
              error={fieldState.invalid}
              helperText={fieldState.error? fieldState.error.message :helpText}
            />
          )}
         />
      </label>
    </div>
  )
}

const CheckBox = ({control, setValue, label, path}) => {
  return(
    <div className='inputRow'>
    <label className='checkBoxLabel'>
      <span className='text'>{label}</span>
      <Controller
        name={path}
        control={control}
        render={({field}) => (
          <Checkbox
            checked={field.value}
            onChange={e => setValue(path, e.target.checked)}
          />
        )}
      />
    </label>
    </div>
  )
}

const CntbkConfigForm = () => {
  const classes = useStyles()
  const dispatch = useDispatch();
  const allstate = useSelector(state=>state);
  const {com, hid, bid, stdDate} = allstate;
  const [resetVal, setResetVal] = useState(true);
  const {handleSubmit, reset, setValue, control} = useForm({
    mode: 'onBlur',
    defaultValues: {
      numOfPhotos: 0, sleep: 0,
      phone: com ?com.tel :"",
      twitter: "https://twitter.com/",
      instagram: "https://www.instagram.com/",
      facebook: "https://ja-jp.facebook.com/",
      website: "",
      temperature: false, bloods: false, excretion: false,
      spo2: false, FtoJ: false, JtoF: false,
      pickupTime: false, pickupPlace: false,
    }
  });

  useEffect(() => {
    const settingContactBook = com.etc 
      ?com.etc.settingContactBook
        ?com.etc.settingContactBook
        :false
      :false;
    if(!settingContactBook) return;
    const defaultValues = Object.keys(settingContactBook).reduce((result, key) => {
      const val = settingContactBook[key];
      if(key === "bitalRequired"){
        const list = val.slice(-2);
        const bitalRequired_keys = ["FtoJ", "JtoF"];
        bitalRequired_keys.forEach((x, index) => result[x] = list[index]);
      }else if(val !== null && typeof(val) === 'object' && val.constructor === Object){
        result = {...result, ...val};
      }else{
        result[key] = val;
      }
      return result
    }, {})
    reset({...defaultValues});
  }, [resetVal])

  const makeFormDtFromKeys = (keys, formDt) => {
    return keys.reduce((resultDt,key) => {
      resultDt[key] = formDt[key];
      return resultDt
    }, {});
  }

  const onSubmit = (formDt) => {
    const links_keys = ["phone", "twitter", "instagram", "facebook", "website"];
    const vital_keys = ["temperature", "bloods", "excretion", "spo2", "sleep"];
    const autoMessage_keys = ["pickupTime", "pickupPlace"];
    const numOfPhotos = formDt["numOfPhotos"];
    const links = makeFormDtFromKeys(links_keys, formDt);
    const vital = makeFormDtFromKeys(vital_keys, formDt);
    const bitalRequired = [false, formDt.FtoJ, formDt.JtoF];
    const autoMessage = makeFormDtFromKeys(autoMessage_keys, formDt);

    const comEtc = com.etc ?com.etc :{};
    comEtc.settingContactBook = {
      numOfPhotos, links, vital, bitalRequired, autoMessage
    };
    const sendPrms = {
      ...com, hid, bid, date: stdDate,
      addiction: com.addiction,
      etc: comEtc,
    };
    dispatch(sendBrunch(sendPrms));
  }

  const phoneValidate = (v) => formatTelNum(v).result ?setValue("phone", formatTelNum(v).format) :"番号が不正";
  return(
    <form className={classes.contBkForm}>
      <div className='H'>リンク設定等</div>
      <div className='forms'>
        <div className='inputRow'>
          <label className='textLabel'>
            <div className='text'>写真枚数制限</div>
            <Controller
              name={"numOfPhotos"}
              control={control}
              render={({field}) => (
                <Select
                  value={field.value}
                  onChange={e =>{
                    setValue("numOfPhotos", e.target.value);
                  }}
                >
                  {Array(4).fill("").map((x,i) => <MenuItem key={i} value={i}>{String(i)}</MenuItem>)}
                </Select>
              )}
            />
          </label>
        </div>
        <InputText control={control} label={"電話番号"} path={"phone"} classNameAdd={"inputPhone"}
          validate={{message: v=>phoneValidate(v)}}
        />
        <InputText control={control} label={"twitter"} path={"twitter"} classNameAdd={"inputText"}
          pattern={{value: /^https:\/\/twitter\.com\//, message: "不正な値"}}
        />
        <InputText control={control} label={"instagram"} path={"instagram"} classNameAdd={"inputText"}
          pattern={{value: /^https:\/\/www\.instagram\.com\//, message: "不正な値"}}
        />
        <InputText control={control} label={"facebook"} path={"facebook"} classNameAdd={"inputText"}
          pattern={{value: /^https:\/\/ja\-jp\.facebook\.com\//, message: "不正な値"}}
        />
        <InputText control={control} label={"ホームページ"} path={"website"} classNameAdd={"inputText"} />
      </div>
      <div className='H'>バイタル設定</div>
      <div className='forms'>
        <CheckBox control={control} setValue={setValue} label={"体温"} path={"temperature"} />
        <CheckBox control={control} setValue={setValue} label={"血圧・脈拍"} path={"bloods"} />
        <CheckBox control={control} setValue={setValue} label={"排泄"} path={"excretion"} />
        <CheckBox control={control} setValue={setValue} label={"血中酸素濃度"} path={"spo2"} />
        <div className='inputRow'>
          <label className='textLabel'>
            <div className='text'>睡眠</div>
            <Controller
              name={"sleep"}
              control={control}
              render={({field}) => (
                <Select
                  value={field.value}
                  onChange={e => setValue("sleep", e.target.value)}
                  style={{minWidth: 120}}
                >
                  <MenuItem value={0}>設定なし</MenuItem>
                  <MenuItem value={1}>時間</MenuItem>
                  <MenuItem value={2}>就寝・起床</MenuItem>
                </Select>
              )}
            />
          </label>
        </div>
        <div style={{display: 'flex'}}>
          <div style={{width: 200, margin: '20px 0'}}>バイタル記述</div>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <div className='inputRow'>
              <label className='checkBoxLabel'>
                <Controller
                  name="FtoJ" control={control}
                  render={({field}) => (
                    <Checkbox
                      checked={field.value}
                      onChange={e => setValue("FtoJ", e.target.checked)}
                    />
                  )}
                />
                <span style={{marginLeft: 8}}>家族から事業所</span>
              </label>
            </div>
            <div className='inputRow'>
              <label className='checkBoxLabel'>
                <Controller
                  name="JtoF" control={control}
                  render={({field}) => (
                    <Checkbox
                      checked={field.value}
                      onChange={e => setValue("JtoF", e.target.checked)}
                    />
                  )}
                />
                <span style={{marginLeft: 8}}>事業所から家族</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className='H'>自動送信設定</div>
      <div className='forms'>
        <CheckBox control={control} setValue={setValue} label={"お迎え時間の記述"} path={"pickupTime"} />
        <CheckBox control={control} setValue={setValue} label={"お迎え場所の記述"} path={"pickupPlace"} />
      </div>
      <div className='button'>
        <Button
          variant='contained'
          onClick={() => setResetVal(resetVal ?false :true)}
          style={{color: "#ffffff", backgroundColor: lightBlue[800], marginRight: 20}}
        >
          キャンセル
        </Button>
        <Button
          variant='contained'
          onClick={handleSubmit(dt => onSubmit(dt))}
          style={{color: "#ffffff", backgroundColor: teal[800]}}
        >
          書き込み
        </Button>
      </div>
    </form>
  )
}

const CntbkConfig = () => {
  return(
    <>
    <CntbkLinksTab />
    <div className='AppPage Cntbkconfig'>
      <CntbkConfigForm /> 
    </div>
    </>
  )
}
export default CntbkConfig